<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="studentPayments"
      :items-per-page="5"
      class="elevation-1"
    >
      <template v-slot:item.id="{ item }">
        <span class="badge bg-success">Paid</span>
        <!-- <v-icon @click="editPayment(index)" v-if="isAdmin">mdi-pencil</v-icon> -->
        <v-icon color="primary" @click="viewPayment(item)" v-if="student"
          >mdi-receipt</v-icon
        >
        <v-icon color="red" @click="deletePayment(item)" v-if="isManager"
          >mdi-delete</v-icon
        >
      </template>
    </v-data-table>
    <GlobalDialogSlot
      v-if="delObj"
      title="Delete Payment"
      :dialog="dialog"
      @close-dialog="closeDialog"
    >
      <v-card-title>{{ delObj.description }}</v-card-title>
      <v-card-subtitle>{{ delObj.amount }}</v-card-subtitle>
      <v-card-subtitle>{{ delObj.entry_date }}</v-card-subtitle>
      <vButton
        class="mx-4 py-4"
        :data="delObj"
        label="Delete Now"
        @button-clicked="deletePaymentNow"
        icon="mdi-delete"
      ></vButton>
    </GlobalDialogSlot>
  </div>
</template>
<script>
import crudJs from "@/plugins/crud";
import vButton from "@/components/Legos/vButton.vue";
import GlobalDialogSlot from "@/components/myLibrary/GlobalDialogSlot.vue";

export default {
  components: { GlobalDialogSlot, vButton },
  props: {
    payments: {
      default: () => [],
    },
    studentProfileFinanceInfo: {
      default: null,
    },
    student: {
      default: null,
    },
  },
  computed: {
    isManager() {
      return this.$store.getters.isManager;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
  },
  watch: {
    payments(newVal) {
      this.studentPayments = newVal;
    },
  },
  mounted() {
    this.studentPayments = this.payments;
  },

  data: () => ({
    studentPayments: [],
    dialog: false,
    delObj: null,
    headers: [
      { text: "SID", value: "sid" },
      { text: "Date", value: "entry_date" },
      { text: "Description", value: "description" },
      { text: "Amount", value: "amount" },
      { text: "Status", value: "id" },
    ],
  }),
  methods: {
    viewPayment(item) {
      this.$router.push({
        name: "payments-receipt",
        params: {
          student: this.student,
          payment: item,
          studentFinance: this.studentProfileFinanceInfo,
        },
      });
    },
    deletePayment(item) {
      this.dialog = true;

      this.delObj = item;
    },
    async deletePaymentNow(item) {
      this.$store.commit("setLoader", true);
      await crudJs.deleteSingleRow("incomes", item.id);
      this.$toast.success("Payment Deleted Successfully!", { duration: 3000 });
      this.$emit("payment-deleted");
      this.$store.commit("setLoader", false);
    },
    closeDialog() {
      this.dialog = false;
    },
  },
};
</script>
